/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_ship_to_this_address = /** @type {(inputs: {}) => string} */ () => {
	return `Doručit na tuto adresu`
};

const da_ship_to_this_address = /** @type {(inputs: {}) => string} */ () => {
	return `Send til denne adresse`
};

const de_ship_to_this_address = /** @type {(inputs: {}) => string} */ () => {
	return `An diese Adresse liefern`
};

const en_ship_to_this_address = /** @type {(inputs: {}) => string} */ () => {
	return `Ship to this address`
};

const es_ship_to_this_address = /** @type {(inputs: {}) => string} */ () => {
	return `Enviar a esta dirección`
};

const fr_ship_to_this_address = /** @type {(inputs: {}) => string} */ () => {
	return `Livrer à cette adresse`
};

const hu_ship_to_this_address = /** @type {(inputs: {}) => string} */ () => {
	return `Szállítás erre a címre`
};

const it_ship_to_this_address = /** @type {(inputs: {}) => string} */ () => {
	return `Spedisci a questo indirizzo`
};

const nl_ship_to_this_address = /** @type {(inputs: {}) => string} */ () => {
	return `Naar dit adres verzenden`
};

const pl_ship_to_this_address = /** @type {(inputs: {}) => string} */ () => {
	return `Wyślij na ten adres`
};

const pt_ship_to_this_address = /** @type {(inputs: {}) => string} */ () => {
	return `Enviar para este endereço`
};

const sv_ship_to_this_address = /** @type {(inputs: {}) => string} */ () => {
	return `Leverera till denna adress`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ship_to_this_address = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ship_to_this_address(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("ship_to_this_address", locale)
	if (locale === "cs") return cs_ship_to_this_address(inputs)
	if (locale === "da") return da_ship_to_this_address(inputs)
	if (locale === "de") return de_ship_to_this_address(inputs)
	if (locale === "en") return en_ship_to_this_address(inputs)
	if (locale === "es") return es_ship_to_this_address(inputs)
	if (locale === "fr") return fr_ship_to_this_address(inputs)
	if (locale === "hu") return hu_ship_to_this_address(inputs)
	if (locale === "it") return it_ship_to_this_address(inputs)
	if (locale === "nl") return nl_ship_to_this_address(inputs)
	if (locale === "pl") return pl_ship_to_this_address(inputs)
	if (locale === "pt") return pt_ship_to_this_address(inputs)
	return sv_ship_to_this_address(inputs)
};